import api from 'Application/api/api';

const getAllMeasureTasksByEmployee = (id, cancelToken = null) =>
    api.get(`/measures/tasks/by-employee/${id}`, { cancelToken });

export default getAllMeasureTasksByEmployee;
